import { useMemo } from 'react';
import { calculateMinimapDimensions } from '../utils/calculateMinimapDimensions';

/**
 * Minimap pixel dimensions and uniform scale from resolved content bounds.
 */
export function useMinimapGeometry(bounds, maxDimensions) {
  const { minimapWidth, minimapHeight, scale } = useMemo(
    () => calculateMinimapDimensions(bounds, maxDimensions),
    [bounds, maxDimensions],
  );

  return { minimapWidth, minimapHeight, scale };
}
